module.exports = ".xml-detail__item{max-height:200px;overflow:auto;margin-top:10px}\n"